<form [formGroup]="form" class="application-form-container" fxLayout="column">

    <div *ngIf="!fileUploaded && STEPS.length >= 2" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="center center"
         fxLayoutAlign.lt-md="start start"
         fxLayoutGap="10px" class="main-container stepper pt-20">
        <ng-container *ngFor="let step of STEPS; let i=index">
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                <div [ngClass]="currentStep >= i+1 ? 'circle' : 'circle disabled'" fxLayoutAlign="center center">
                    <div class="number" fxLayoutAlign="center center">{{i + 1}}</div>
                </div>
                <div [ngClass]="currentStep >= i+1 ? 'subtitle' : 'subtitle disabled'">
                    {{(step)|i18n}}
                </div>
            </div>
            <div *ngIf="i+1 !== STEPS.length" class="line" fxFlex fxShow.lt-md="false"></div>
            <div *ngIf="i+1 !== STEPS.length" class="bar" fxFlex fxShow.gt-sm="false"></div>
        </ng-container>
    </div>

    <!-- STEP 1: Choose upload mode -->
    <ng-container *ngIf="currentStep === 1">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="24px">
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="text-0">{{'Choose upload mode:'|i18n}}</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="24px">
                <button type="button" class="upload-mode-card"
                        fxFlex="40" fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="12px"
                        (click)="onSelectMode('distributor')">
                    <app-icon name="fal-file-csv" class="upload-mode-icon"></app-icon>
                    <span class="text-4 mt-16">{{'Distributor file'|i18n}}</span>
                    <span class="text-2 mt-16">{{'Upload the file provided by the distributor'|i18n}}</span>
                </button>
                <button type="button" class="upload-mode-card"
                        fxFlex="40" fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="12px"
                        (click)="onSelectMode('template')">
                    <app-icon name="fal-file-excel" class="upload-mode-icon"></app-icon>
                    <span class="text-4 mt-16">{{'Template'|i18n}}</span>
                    <span class="text-2 mt-16">{{'Download, fill and upload the standard template'|i18n}}</span>
                </button>
            </div>
        </div>
    </ng-container>

    <!-- STEP 2 (template mode): Choose time unit -->
    <ng-container *ngIf="currentStep === 2 && uploadMode === 'template'">
        <div fxLayout="row" class="panel" fxLayoutAlign="center center" fxLayoutGap="10px">
            <span class="text-0">{{"Choose a measure unit:"|i18n}}</span>
            <div class="mat-select" fxFlex="30">
                <mat-select formControlName="timeRange" app-small-select (selectionChange)="onSelectTimeFilter($event)">
                    <mat-option *ngFor="let timerange of TIME_RANGES| keyvalue" [value]="timerange.value">
                        {{timerange.key|i18n}}
                    </mat-option>
                </mat-select>
            </div>
        </div>
    </ng-container>

    <!-- STEP 3 (template mode): Choose Period -->
    <ng-container *ngIf="currentStep === 3 && uploadMode === 'template'">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px">
            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign.gt-sm="space-between start"
                 fxLayoutGap.lt-md="30px">
                <span class="text-0">{{"For which period would you like to upload measures?"|i18n}}</span>
            </div>
            <form [formGroup]="customTimeRangeForm" class="mt-20" fxLayout="column">
                <div fxLayout="column" fxLayoutGap="20px">
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="txt-p-16-4">
                        <div fxFlex="20" class="txt-p-16-4">{{'Start date and time:'|i18n}}</div>
                        <div app-input-container fxFlex="25" fxLayout="row" fxLayoutAlign="start center"
                             fxLayoutGap="4px">
                            <input app-input [matDatepicker]="startDate"
                                   [min]="startMinDate"
                                   [max]="startMaxDate"
                                   formControlName="startDate">
                            <mat-datepicker-toggle [for]="startDate"></mat-datepicker-toggle>
                            <mat-datepicker #startDate></mat-datepicker>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px"
                             class="txt-p-16-4 time-picker">
                            <div class="hour-input-wrapper">
                                <div app-input-container>
                                    <input app-input type="number"
                                           [min]="minHour"
                                           [max]="startMaxHour"
                                           formControlName="startHour">
                                </div>
                            </div>
                            <div>:</div>
                            <ng-container *ngIf="isQuarterly; else startHourOnly">
                                <div class="minute-wrapper">
                                    <mat-select formControlName="startMinute" app-small-select>
                                        <mat-option *ngFor="let m of MINUTE_OPTIONS" [value]="m"
                                                    [disabled]="m > startMaxMinute">
                                            {{m === 0 ? '00' : m}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </ng-container>
                            <ng-template #startHourOnly><div>00</div></ng-template>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="txt-p-16-4">
                        <div fxFlex="20" class="txt-p-16-4">{{'End date and time:'|i18n}}</div>
                        <div app-input-container fxFlex="25" fxLayout="row" fxLayoutAlign="start center"
                             fxLayoutGap="4px">
                            <input app-input [matDatepicker]="endDate"
                                   [min]="endMinDate"
                                   [max]="endMaxDate"
                                   formControlName="endDate">
                            <mat-datepicker-toggle [for]="endDate"></mat-datepicker-toggle>
                            <mat-datepicker #endDate></mat-datepicker>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px"
                             class="txt-p-16-4 time-picker">
                            <div class="hour-input-wrapper">
                                <div app-input-container>
                                    <input app-input type="number"
                                           [min]="minHour"
                                           [max]="endMaxHour"
                                           formControlName="endHour">
                                </div>
                            </div>
                            <div>:</div>
                            <ng-container *ngIf="isQuarterly; else endHourOnly">
                                <div class="minute-wrapper">
                                    <mat-select formControlName="endMinute" app-small-select>
                                        <mat-option *ngFor="let m of MINUTE_OPTIONS" [value]="m"
                                                    [disabled]="m > endMaxMinute">
                                            {{m === 0 ? '00' : m}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </ng-container>
                            <ng-template #endHourOnly><div>00</div></ng-template>
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="10px">
                        <div *ngIf="customTimeRangeForm.hasError('fromdateAfterTodate')"
                             fxLayout="row" fxLayoutAlign="center" app-error>
                            <div>{{'End date must follow start date'|i18n}}</div>
                        </div>
                        <div *ngIf="customTimeRangeForm.hasError('startHourOutOfRange')"
                             fxLayout="row" fxLayoutAlign="center" app-error>
                            <div>{{'Start hour out of range'|i18n}}</div>
                        </div>
                        <div *ngIf="customTimeRangeForm.hasError('endHourOutOfRange')"
                             fxLayout="row" fxLayoutAlign="center" app-error>
                            <div>{{'End hour out of range'|i18n}}</div>
                        </div>
                        <div *ngIf="customTimeRangeForm.hasError('quarterlyRangeTooShort')"
                             fxLayout="row" fxLayoutAlign="center" app-error>
                            <div>{{'The time range must be at least 1 hour long'|i18n}}</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>

    <!-- STEP 2 (distributor mode, non-prosumer): Upload single distributor file -->
    <ng-container *ngIf="currentStep === 2 && uploadMode === 'distributor' && !isProsumerResource">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="24px">
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="text-0">{{"Upload the file provided by the distributor:"|i18n}}</span>
            </div>
            <div fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <span class="txt-p-16-4">{{'File:'|i18n}}</span>
                    <input #distFileSelect type="file" style="display: none"
                           [accept]="CSV_ACCEPT"
                           (change)="onClickUploadDistributorAbsorbed($event)">
                    <button app-primary-button type="button"
                            (click)="distFileSelect.click()">
                        <app-icon [name]="distributorFileAbsorbed.name ? 'fal-sync' : 'fal-search'"></app-icon>
                        {{(distributorFileAbsorbed.name ? 'Change file' : 'Select file')|i18n}}
                    </button>
                    <span *ngIf="distributorFileAbsorbed?.name" class="txt-p-16-4">{{distributorFileAbsorbed?.name}}</span>
                    <div *ngIf="!distributorFileAbsorbed.name" class="txt-s-14-4">{{'No file selected'|i18n}}</div>
                    <button *ngIf="distributorFileAbsorbed.name" app-icon-button class="app-button-alert"
                            (click)="onClickTrashDistributorAbsorbed(distFileSelect)">
                        <app-icon name="fal-trash-alt"></app-icon>
                    </button>
                </div>
                <span fxLayoutAlign="center center" class="txt-s-14-4">
                    {{'(Max {0} MB. Accepts only CSV files.)'|i18n:MAX_FILE_MB}}
                </span>
            </div>
        </div>
    </ng-container>

    <!-- STEP 2 (distributor mode, prosumer): Upload absorbed energy file -->
    <ng-container *ngIf="currentStep === 2 && uploadMode === 'distributor' && isProsumerResource">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="24px">
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="text-0">{{"Upload the absorbed energy file provided by the distributor:"|i18n}}</span>
            </div>
            <div fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <span class="txt-p-16-4">{{'Absorbed energy file:'|i18n}}</span>
                    <input #distAbsorbedFileSelect type="file" style="display: none"
                           [accept]="CSV_ACCEPT"
                           (change)="onClickUploadDistributorAbsorbed($event)">
                    <button app-primary-button type="button"
                            (click)="distAbsorbedFileSelect.click()">
                        <app-icon [name]="distributorFileAbsorbed.name ? 'fal-sync' : 'fal-search'"></app-icon>
                        {{(distributorFileAbsorbed.name ? 'Change file' : 'Select file')|i18n}}
                    </button>
                    <span *ngIf="distributorFileAbsorbed?.name" class="txt-p-16-4">{{distributorFileAbsorbed?.name}}</span>
                    <div *ngIf="!distributorFileAbsorbed.name" class="txt-s-14-4">{{'No file selected'|i18n}}</div>
                    <button *ngIf="distributorFileAbsorbed.name" app-icon-button class="app-button-alert"
                            (click)="onClickTrashDistributorAbsorbed(distAbsorbedFileSelect)">
                        <app-icon name="fal-trash-alt"></app-icon>
                    </button>
                </div>
                <span fxLayoutAlign="center center" class="txt-s-14-4">
                    {{'(Max {0} MB. Accepts only CSV files.)'|i18n:MAX_FILE_MB}}
                </span>
            </div>
        </div>
    </ng-container>

    <!-- STEP 3 (distributor mode, prosumer): Upload injected energy file -->
    <ng-container *ngIf="currentStep === 3 && uploadMode === 'distributor' && isProsumerResource">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="24px">
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="text-0">{{"Upload the injected energy file provided by the distributor:"|i18n}}</span>
            </div>
            <div fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <span class="txt-p-16-4">{{'Injected energy file:'|i18n}}</span>
                    <input #distInjectedFileSelect type="file" style="display: none"
                           [accept]="CSV_ACCEPT"
                           (change)="onClickUploadDistributorInjected($event)">
                    <button app-primary-button type="button"
                            (click)="distInjectedFileSelect.click()">
                        <app-icon [name]="distributorFileInjected.name ? 'fal-sync' : 'fal-search'"></app-icon>
                        {{(distributorFileInjected.name ? 'Change file' : 'Select file')|i18n}}
                    </button>
                    <span *ngIf="distributorFileInjected?.name" class="txt-p-16-4">{{distributorFileInjected?.name}}</span>
                    <div *ngIf="!distributorFileInjected.name" class="txt-s-14-4">{{'No file selected'|i18n}}</div>
                    <button *ngIf="distributorFileInjected.name" app-icon-button class="app-button-alert"
                            (click)="onClickTrashDistributorInjected(distInjectedFileSelect)">
                        <app-icon name="fal-trash-alt"></app-icon>
                    </button>
                </div>
                <span fxLayoutAlign="center center" class="txt-s-14-4">
                    {{'(Max {0} MB. Accepts only CSV files.)'|i18n:MAX_FILE_MB}}
                </span>
            </div>
        </div>
    </ng-container>

    <!-- STEP 4 (template mode): Download template -->
    <ng-container *ngIf="currentStep === 4 && uploadMode === 'template'">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="24px">
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="text-0">{{"Download the template and fill it with the measures"|i18n}}</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center">
                <button app-primary-button
                        (click)="onClickDownloadTemplate()">
                    <app-icon name="fal-download"></app-icon>
                    {{'Download template'|i18n}}
                </button>
            </div>
            <span *ngIf="this.templateDownloaded" fxLayoutAlign="center center" class="txt-s-14-4">
                {{'File downloaded! Proceed with the next step'|i18n}}
            </span>
        </div>
    </ng-container>

    <!-- STEP 5 (template mode): Upload file -->
    <ng-container *ngIf="currentStep === 5 && uploadMode === 'template'">
        <div class="panel" fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="24px">
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="text-0">{{"Upload your modified file:"|i18n}}</span>
            </div>
            <div fxLayout="column" fxLayoutAlign="stretch" fxLayoutGap="10px">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <span class="txt-p-16-4">{{'Edited file:'|i18n}}</span>
                    <input #fileSelect type="file" style="display: none"
                           [accept]="XLSX_MIME_TYPE"
                           (change)="onClickUploadTemplate($event)">
                    <button app-primary-button
                            (click)="fileSelect.click()">
                        <app-icon [name]="templateChosen ? 'fal-sync' : 'fal-search'"></app-icon>
                        {{(templateChosen ? 'Change file' : 'Select file')|i18n}}
                    </button>
                    <span *ngIf="this.template?.name" class="txt-p-16-4">{{this.template?.name}}</span>
                    <div *ngIf="!this.template.name"
                         class="txt-s-14-4">{{'No file uploaded'|i18n}}</div>
                    <button *ngIf="templateChosen" app-icon-button class="app-button-alert"
                            (click)="onClickTrashTemplate(fileSelect)">
                        <app-icon name="fal-trash-alt"></app-icon>
                    </button>
                </div>
                <span fxLayoutAlign="center center" class="txt-s-14-4">
                    {{'(Max {0} MB. Accepts only XLSX files.)'|i18n:MAX_FILE_MB}}
                </span>
            </div>
        </div>
    </ng-container>

    <div fxLayout="row" fxLayoutAlign="space-evenly" class="mt-42">
        <button *ngIf="currentStep === 1" app-ghost-button type="button"
                [mat-dialog-close]="false">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <app-icon name="fal-times"></app-icon>
                <span>{{'Cancel'|i18n}}</span>
            </div>
        </button>
        <button *ngIf="currentStep > 1 && !fileUploaded" app-ghost-button type="button"
                (click)="prevStep()">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <app-icon name="fal-arrow-left"></app-icon>
                <span>{{'Back'|i18n}}</span>
            </div>
        </button>
        <button *ngIf="currentStep > 1 && currentStep < STEPS.length" app-primary-button type="button"
                [disabled]="!isNextEnabled(currentStep)"
                (click)="nextStep()">
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
                <span>{{'Next'|i18n}}</span>
                <app-icon name="fal-arrow-right" class="right-icon"></app-icon>
            </div>
        </button>
        <button *ngIf="currentStep !== 1 && currentStep === STEPS.length" app-primary-button type="button"
                (click)="onClickSend()"
                [disabled]="!isLastStepValid"
                [matDialogClose]="true">
            <app-icon name="fal-save"></app-icon>
            {{'Save Data'|i18n}}
        </button>
    </div>

</form>

<ng-template #spinner let-data="data" let-close="close">
    <app-spinner [spinnerDataSubj]="data"
                 (closeSpinner)="close()">
    </app-spinner>
</ng-template>
